<script lang="ts">
export default {
  name: 'Alert',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { X } from 'lucide-vue-next';

const props = withDefaults(
  defineProps<{
    type?: 'info' | 'success' | 'warning' | 'error';
    title?: string;
    closable?: boolean;
    icon?: any;
    class?: string;
  }>(),
  {
    type: 'info',
    closable: false,
  },
);

const emit = defineEmits<{
  close: [];
}>();

const alertClasses = computed(() => {
  const classes = ['tw:alert'];

  switch (props.type) {
    case 'success':
      classes.push('tw:alert-success');
      break;
    case 'warning':
      classes.push('tw:alert-warning');
      break;
    case 'error':
      classes.push('tw:alert-error');
      break;
    case 'info':
    default:
      classes.push('tw:alert-info');
      break;
  }

  if (props.class) {
    classes.push(props.class);
  }

  return classes.join(' ');
});

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <div
    :class="alertClasses"
    class="tw:flex tw:items-center tw:gap-2 tw:font-bold">
    <div class="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-2">
      <component
        v-if="icon"
        :is="icon"
        class="tw:h-5 tw:w-5 tw:shrink-0" />
      <slot
        v-if="!icon && !title && !$slots.default"
        name="icon">
        <!-- Default icon based on type if no icon provided -->
      </slot>
      <div class="tw:min-w-0 tw:flex-1">
        <h3
          v-if="title"
          class="tw:font-bold">
          {{ title }}
        </h3>
        <div>
          <slot />
        </div>
      </div>
    </div>
    <button
      v-if="closable"
      class="tw:btn tw:btn-square tw:shrink-0 tw:btn-ghost tw:btn-sm"
      @click="handleClose">
      <X
        :size="16"
        class="tw:h-4 tw:w-4" />
    </button>
  </div>
</template>
